module.exports = __webpack_public_path__ + "static/media/generalSurgery-image1@3x.03a9c4ec.png";